import type { AgentCard } from "@/stores/agent-store";
import type { StudioCard } from "@/pages/studio/notebook-markdown";
import { StudioProposalCard } from "@/pages/studio/StudioProposalCard";
import { StudioRecordEntryCard, type NotebookFile } from "@/pages/studio/StudioRecordEntryCard";

// One component per card kind a browser-executed tool can attach to an answer. `onChange` makes it editable
// where the card is kept (the Studio notebook); without it the card is read-only. `notebookFile` is the open
// notebook, for a card that can file it.
export function AgentCardView({ card, onChange, notebookFile }: {
  card: AgentCard;
  onChange?: (next: StudioCard) => void;
  notebookFile?: NotebookFile;
}) {
  switch (card.kind) {
    case "studioProposal":
      return <StudioProposalCard proposal={card.data} onChange={onChange ? (data) => onChange({ kind: card.kind, data }) : undefined} />;
    case "orgRecordEntry":
      return (
        <StudioRecordEntryCard
          draft={card.data}
          notebookFile={notebookFile}
          onChange={onChange ? (data) => onChange({ kind: card.kind, data }) : undefined}
        />
      );
  }
}
